import styled from "styled-components";

import { pxToRem } from "../../styles/utils";

export const CalendarShell = styled.section<{ $compact?: boolean }>`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.borderDark};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

export const CalendarHeader = styled.header<{ $compact?: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${pxToRem(14)};
  flex-wrap: wrap;
  padding: ${({ $compact }) => ($compact ? `${pxToRem(10)} ${pxToRem(12)}` : `${pxToRem(14)} ${pxToRem(18)}`)};
  border-bottom: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
  background: ${({ theme }) => theme.colors.white};
`;

export const CalendarTitle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${pxToRem(6)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(14)};
  font-weight: 600;
  line-height: 1.2;
`;

export const CalendarMeta = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin-left: auto;
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(12)};
  line-height: 1.2;

  @media (max-width: 640px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const CalendarBody = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? pxToRem(6) : pxToRem(10))};
  overflow-x: auto;
  overflow-y: hidden;
  padding: ${({ $compact }) => ($compact ? `${pxToRem(8)} ${pxToRem(10)} ${pxToRem(10)}` : `${pxToRem(14)} ${pxToRem(18)} ${pxToRem(16)}`)};
  background: ${({ theme }) => theme.colors.surfaceMuted};
`;

export const CalendarWeekdays = styled.div<{ $compact?: boolean }>`
  display: grid;
  flex-shrink: 0;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: ${({ $compact }) => ($compact ? pxToRem(6) : pxToRem(10))};

  @media (max-width: 900px) {
    min-width: ${pxToRem(760)};
  }
`;

export const CalendarWeekday = styled.div`
  padding: 0 ${pxToRem(6)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(12)};
  font-weight: 600;
  line-height: 1.2;
`;

export const CalendarGrid = styled.div<{ $compact?: boolean }>`
  display: grid;
  flex: 1;
  min-height: 0;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-auto-rows: ${({ $compact }) => ($compact ? `minmax(${pxToRem(88)}, 1fr)` : `minmax(${pxToRem(110)}, 1fr)`)};
  gap: ${({ $compact }) => ($compact ? pxToRem(6) : pxToRem(9))};
  overflow: visible;

  @media (max-width: 900px) {
    min-width: ${pxToRem(760)};
  }
`;

export const CalendarFooter = styled.footer<{ $compact?: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: ${pxToRem(12)};
  flex-wrap: wrap;
  margin-top: auto;
  padding: ${({ $compact }) => ($compact ? `${pxToRem(8)} ${pxToRem(10)}` : `${pxToRem(10)} ${pxToRem(18)}`)};
  border-top: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
  background: ${({ theme }) => theme.colors.white};
`;

export const CalendarFooterActions = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
`;
